import Vue from "vue";

const state = {
  cashout_requests: [],
  totalCashoutAmount: 0,
  loading: true
};
const getters = {
  cashout_requests: state => {
    return state.cashout_requests;
  },
  totalCashoutAmount: state => {
    return state.totalCashoutAmount;
  },
  loading: state => {
    return state.loading;
  }
};

const actions = {
  cashoutrequests(context, payload) {
    return Vue.prototype.$http.get("/api/cashout-requests/v1" + payload);
  },
  create(context, payload) {
    return Vue.prototype.$http.post("/api/cashout-requests/v1", payload.models);
  }
};

const mutations = {
  cashout_requests(state, payload) {
    state.cashout_requests = payload;
  },
  loading(state, payload) {
    state.loading = payload;
  },
  add(state, payload) {
    state.cashout_requests.push(payload);
  },
  totalCashoutAmount(state, payload) {
    state.totalCashoutAmount = payload;
  }
};

export const cashout_requests = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
